import React from "react";

const SVG = ({
  style = {},
  fill = "#1D1D1B",
  width = "100%",
  className = "",
  viewBox = "0 0 100 100"
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      fill={fill}
      d="M13.4,78.1H7.8c-1.6,0-2.8-1.3-2.8-2.8c0-1.6,1.3-2.8,2.8-2.8h5.6c1.6,0,2.8,1.3,2.8,2.8
        C16.3,76.9,15,78.1,13.4,78.1z M95,16.3v67.5C95,90,90,95,83.7,95H21.9c-6.2,0-11.2-5-11.2-11.3h2.8c4.7,0,8.4-3.8,8.4-8.4
        c0-4.7-3.8-8.4-8.4-8.4h-2.8V33.1h2.8c4.7,0,8.4-3.8,8.4-8.4c0-4.7-3.8-8.4-8.4-8.4h-2.8C10.6,10,15.7,5,21.9,5h61.9
        C90,5,95,10,95,16.3z M89.4,16.3c0-3.1-2.5-5.6-5.6-5.6H33.1v78.7h50.6c3.1,0,5.6-2.5,5.6-5.6V16.3z M7.8,27.5h5.6
        c1.6,0,2.8-1.3,2.8-2.8c0-1.6-1.3-2.8-2.8-2.8H7.8c-1.6,0-2.8,1.3-2.8,2.8C5,26.2,6.3,27.5,7.8,27.5z M80.9,16.3H41.6
        c-1.6,0-2.8,1.3-2.8,2.8c0,1.6,1.3,2.8,2.8,2.8h39.4c1.6,0,2.8-1.3,2.8-2.8C83.7,17.5,82.5,16.3,80.9,16.3z M80.9,27.5H41.6
        c-1.6,0-2.8,1.3-2.8,2.8c0,1.6,1.3,2.8,2.8,2.8h39.4c1.6,0,2.8-1.3,2.8-2.8C83.7,28.8,82.5,27.5,80.9,27.5z M80.9,38.8H41.6
        c-1.6,0-2.8,1.3-2.8,2.8c0,1.6,1.3,2.8,2.8,2.8h39.4c1.6,0,2.8-1.3,2.8-2.8C83.7,40,82.5,38.8,80.9,38.8z M80.9,50H41.6
        c-1.6,0-2.8,1.3-2.8,2.8c0,1.6,1.3,2.8,2.8,2.8h39.4c1.6,0,2.8-1.3,2.8-2.8C83.7,51.3,82.5,50,80.9,50z M80.9,61.2H41.6
        c-1.6,0-2.8,1.3-2.8,2.8c0,1.6,1.3,2.8,2.8,2.8h39.4c1.6,0,2.8-1.3,2.8-2.8C83.7,62.5,82.5,61.2,80.9,61.2z M64.1,72.5H41.6
        c-1.6,0-2.8,1.3-2.8,2.8c0,1.6,1.3,2.8,2.8,2.8h22.5c1.6,0,2.8-1.3,2.8-2.8C66.9,73.8,65.6,72.5,64.1,72.5z"
    />
  </svg>
);

export default SVG;